// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__QtkvL","emails":"CreateEditClinics_emails__2j3Jp","emailTagLabel":"CreateEditClinics_emailTagLabel__3YAsO"};